import { isMyAppWKWebView } from "./isMyAppWKWebView";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export async function saveData(data: Record<string, any>) {
  if (window.Android) {
    return window.Android.saveData(JSON.stringify(data));
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.saveData.postMessage(data);
  }

  try {
    localStorage.setItem('skillscratch_data', JSON.stringify(data));
    return true;
  } catch (error) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    throw new Error(`Failed to load data: ${(error as unknown as any).message || 'Unknown error'}`);
  }
}
